// src/pages/Auth/PhoneEntry.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { requestOtpThunk } from "../../redux/features/Auth/authThunk";
import { Loader2, Phone, ArrowLeft } from "lucide-react";

const PhoneEntry = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  const [phone, setPhone] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (phone.length !== 11) {
      alert("شماره تلفن باید ۱۱ رقم باشد.");
      return;
    }
    dispatch(requestOtpThunk(phone)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        navigate("/verify-otp", { state: { phone } });
      }
    });
  };

  return (
    <div className="min-h-screen bg-[#F0F4EB] flex items-center justify-center py-8 px-4" dir="rtl">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-[#DCE4D3]">
          <div className="relative bg-gradient-to-l from-[#8A9A7B] to-[#9EAD8C] px-6 py-8 text-white">
            <button
              onClick={() => navigate(-1)}
              className="absolute top-4 right-4 p-2 rounded-lg bg-white/20 hover:bg-white/30 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3">
                <Phone className="w-8 h-8 text-white" />
              </div>
              <h1 className="text-2xl font-bold">ورود / ثبت‌نام</h1>
              <p className="text-white/80 text-sm mt-1">
                شماره تلفن خود را وارد کنید
              </p>
            </div>
          </div>

          <div className="p-6">
            <form onSubmit={handleSubmit}>
              <div className="relative">
                <Phone className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="tel"
                  placeholder="مثال: ۰۹۱۲۳۴۵۶۷۸۹"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  maxLength="11"
                  className="w-full pr-11 pl-4 py-3 border-2 border-gray-200 rounded-xl text-sm focus:border-[#8A9A7B] outline-none transition-all"
                  required
                />
              </div>
              {error && (
                <p className="text-red-500 text-sm mt-2 flex items-center gap-1">
                  <span className="inline-block w-1 h-1 bg-red-500 rounded-full" />
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={loading}
                className="w-full mt-4 py-3.5 bg-[#8A9A7B] text-white rounded-xl font-bold hover:bg-[#6A7A5B] transition-all disabled:opacity-50 flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 animate-spin" />
                    در حال ارسال...
                  </>
                ) : (
                  "ارسال کد تایید"
                )}
              </button>
            </form>

            <div className="mt-6 pt-4 border-t border-gray-100 text-center text-xs text-gray-400">
              <p>کد تایید از طریق پیامک برای شما ارسال خواهد شد.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhoneEntry;